module.exports = __webpack_public_path__ + "static/04-27bedf1dd0c1528d08b62de498649971.jpg";